
import Vue from 'vue'

import CustomTextModal from './CustomTextModal.vue'
import { RButton, RInput } from '@/components'

export default Vue.extend({
  name: 'ItemRenameModal',
  components: {
    CustomTextModal,
    RButton,
    RInput,
  },
  props: {
    pending: {
      type: Boolean,
    },
    currentItemName: {
      type: String,
    },
  },
  data() {
    return {
      newName: '',
    }
  },
  methods: {
    emit(): void {
      const { newName, valid } = this
      if (!valid) return
      this.$emit('rename', newName)
    },
  },

  computed: {
    valid(): boolean {
      const { newName, currentItemName } = this
      return newName ? newName !== currentItemName : false
    },
  },
})
